import React from 'react';

const DownVoteIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.61133 13.0719L7.61103 13.0715L0.812662 4.91821L0.755367 4.84855C0.751856 4.84021 0.750001 4.83136 0.750001 4.82334C0.750001 4.78813 0.780267 4.75 0.830001 4.75L15.17 4.75C15.2197 4.75 15.25 4.78813 15.25 4.82335C15.25 4.83122 15.2488 4.83891 15.2466 4.84631L15.1782 4.92686L15.1782 4.92684L15.1743 4.93156L8.38163 13.0684C8.28454 13.1817 8.14449 13.25 7.995 13.25C7.8386 13.25 7.70267 13.1816 7.61133 13.0719Z'
      stroke='#E60053'
      strokeWidth='1.5'
    />
  </svg>
);

export default DownVoteIcon;
